import { render, staticRenderFns } from "./exchangeDetail.vue?vue&type=template&id=05f13fcc"
import script from "./exchangeDetail.vue?vue&type=script&lang=js"
export * from "./exchangeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports